import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TranslationModule } from '@examsoft/translation';

import { AppRouteModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { NotFoundComponent } from './not-found/not-found.component';

import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { environment } from 'src/environments/environment';
import { AppState } from './shared/state/app.state';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { LaunchDarklyService } from './shared/services/launchDarkly.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DeviceState } from './shared/state/device.state';
import { PaymentState } from './payment/state/payment.state';
import { APPLICATION_WINDOW } from './app.constants';

@NgModule({
  declarations: [AppComponent, NotFoundComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    SharedModule,
    AppRouteModule,
    DeviceDetectorModule,
    ClipboardModule,
    NgxsModule.forRoot([AppState, DeviceState, PaymentState], {
      developmentMode: !environment.production,
      selectorOptions: {
        suppressErrors: false,
        injectContainerState: false,
      },
    }),
    NgxsStoragePluginModule.forRoot({
      key: 'app',
    }),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    BrowserAnimationsModule,
    TranslationModule.forRoot({
      defaultLanguage: 'en',
      languages: {
        ar: { isRTL: true },
        es: { isRTL: false },
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APPLICATION_WINDOW,
      useValue: window,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (ldService: LaunchDarklyService) => async () => {
        return await ldService.initialize(environment?.launchDarklySecretKey);
      },
      deps: [LaunchDarklyService],
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
